
import React from 'react'
import { mdx } from '@mdx-js/react'

/* @jsxRuntime classic */
/* @jsx mdx */

import DocsBeta from 'src/components/docs/DocsBeta/index.tsx';
import Layout from '../../../../components/docs/Layout';
import Actions from '../../../../components/docs/Actions';
export const metadata = {
  toc: true,
  title: 'API Reference',
  section: 'API Reference',
  layout: 'reference',
  description: 'Endpoints and data definitions'
};
const makeShortcode = name => function MDXDefaultShortcode(props) {
      console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope")
      return <div {...props}/>
    };
const Header = makeShortcode("Header");
const Tag = makeShortcode("Tag");
const Help = makeShortcode("Help");
const layoutProps = {
  metadata
};
const MDXLayout = "wrapper"
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">



    <Header title='API Reference' subtitle='Endpoints and data definitions' mdxType="Header" />
    <Actions.Wrapper>
  <Actions.Card icon={<Tag mdxType="Tag" />} title='Core Exchange v6.4' subtitle="Reference for building the latest version of Plaid's FDX-aligned Core Exchange API" link='/core-exchange/docs/reference/6.4' linkText='Endpoints & data dictionary' />
  <Actions.Card icon={<Tag mdxType="Tag" />} title='Core Exchange v6.3' subtitle="Reference for building Plaid's Core Exchange v6.3 API" link='/core-exchange/docs/reference/6.3' linkText='Endpoints & data dictionary' />
  <Actions.Card icon={<Tag mdxType="Tag" />} title='Core Exchange v6.2' subtitle="Reference for building Plaid's Core Exchange v6.2 API" link='/core-exchange/docs/reference/6.2' linkText='Endpoints & data dictionary' />
  <Actions.Card icon={<Tag mdxType="Tag" />} title='Core Exchange v6.1' subtitle="Reference for building Plaid's Core Exchange v6.1 API" link='/core-exchange/docs/reference/6.1' linkText='Endpoints & data dictionary' />
  <Actions.Card icon={<Tag mdxType="Tag" />} title='Core Exchange v6.0' subtitle="Reference for building Plaid's Core Exchange v6.0 API" link='/core-exchange/docs/reference/6.0' linkText='Endpoints & data dictionary' />
  <Actions.Card icon={<Tag mdxType="Tag" />} title='Core Exchange v5.3' subtitle="Reference for building Plaid's Core Exchange v5.3 API" link='/core-exchange/docs/reference/5.3' linkText='Endpoints & data dictionary' />
  <Actions.Card icon={<Tag mdxType="Tag" />} title='Core Exchange v5.2' subtitle="Reference for building Plaid's Core Exchange v5.2 API" link='/core-exchange/docs/reference/5.2' linkText='Endpoints & data dictionary' />
  <Actions.Card icon={<Tag mdxType="Tag" />} title='Core Exchange v5.1' subtitle="Reference for building Plaid's Core Exchange v5.1 API" link='/core-exchange/docs/reference/5.1' linkText='Endpoints & data dictionary' />
  <Actions.Card icon={<Tag mdxType="Tag" />} title='Core Exchange v5.0' subtitle="Reference for building Plaid's Core Exchange v5.0 API" link='/core-exchange/docs/reference/5.0' linkText='Endpoints & data dictionary' />
  <Actions.Card icon={<Tag mdxType="Tag" />} title='Core Exchange v4.6' subtitle="Reference for building Plaid's Core Exchange v4.6 API" link='/core-exchange/docs/reference/4.6' linkText='Endpoints & data dictionary' />
  <Actions.Card icon={<Help mdxType="Help" />} title='Data mapping guide' subtitle='FAQs and common pitfalls in data mapping' link='/core-exchange/docs/data-mapping-guide' linkText='Read the guide' />
    </Actions.Wrapper>
    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;

            export const tableOfContents = [
      
];
          
layoutProps.tableOfContents = tableOfContents;
MDXContent.layoutProps = layoutProps;

MDXContent.layout = function (props) { return <DocsBeta {...props} /> };
